import { Component, OnInit, inject, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { buffer, finalize } from 'rxjs';

import { InventoryService } from 'src/app/services/inventory.service';
import { PaginationComponent } from 'src/app/components/pagination/pagination.component';
import { GetCatalogResourceInventory } from 'src/app/models/inventory/inventory';
import { ModalInventoryManagementComponent } from './modal-inventory-management/modal-inventory-management.component';

@Component({
  selector: 'app-inventory',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginationComponent, ModalInventoryManagementComponent],
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.css']
})
export class InventoryComponent implements OnInit {

  private inventoryService = inject(InventoryService);

  resources = signal<GetCatalogResourceInventory[]>([]);
  isLoading = signal(false);

  page = signal(1);
  pageSize = signal(10);
  total = signal(0);

  filterName = signal<string | null>(null);
  filterType = signal<'ALL' | 'INVENTORY' | 'SEATS'>('ALL');

  public modalInventoryManagementComponent = viewChild(ModalInventoryManagementComponent);

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.isLoading.set(true);

    this.inventoryService
      .getResourcesWithInventory(
        this.filterName() || undefined,
        this.filterType() === 'ALL' ? undefined : this.filterType(),
        {
          page: this.page(),
          pageSize: this.pageSize()
        })
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe(res => {
        this.resources.set(res.items);
        this.total.set(res.totalItems);
      });
  }

  applyFilters() {
    this.page.set(1);
    this.load();
  }

  clearFilters() {
    this.filterName.set(null);
    this.filterType.set('ALL');
    this.applyFilters();
  }

  onPageChange(page: number) {
    this.page.set(page);
    this.load();
  }

  onPageSizeChange(size: number) {
    this.pageSize.set(size);
    this.page.set(1);
    this.load();
  }

  manage(item: GetCatalogResourceInventory) {
    const component = this.modalInventoryManagementComponent();
    if (component) {
      component.open(item);
    }
  }

  exportCsv() {
    this.inventoryService.exporttResourcesWithInventoryCsv(
      this.filterName() || undefined,
      this.filterType() === 'ALL' ? undefined : this.filterType()
    ).subscribe({
      next: (buffer) => {
        const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `Inventario y Cupos_${new Date().toISOString()}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  }

}